export default __webpack_public_path__ + "static/media/equip-title.af7bfeeb.png";